/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {depositCheck} from '../api'

export const useMutationDepositCheck = createReactQueryMutationHook('depositCheck', depositCheck)
